<template>
  <div>
    <ml-table :columns="columns" :data-source="data" :scroll="{y: scrallHeight}" :loading="loading">
      <template
        slot="name"
        slot-scope="text, record"
      >
        <div>
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :value="text"
            @change="e => handleChange(e.target.value, record.key, 'name')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template
        slot="color"
        slot-scope="text, record"
      >
        <div>
          <!-- <a-input
            v-if="record.editable"
            type="color"
            style="margin: -5px 0"
            :value="text"
            @change="e => handleChange(e.target.value, record.key, 'color')"
          /> -->
          <colorPicker style="margin: -5px 0"  v-if="record.editable" v-model="record.color" @change="e => handleChange(e, record.key, 'color')"/>
          <template v-else>
            <div :style="{backgroundColor: text,height: '20px',width: '100%'}"></div>
          </template>
        </div>
      </template>
      <template slot="canEditor" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a v-acl="'page_mdc_setting_condition_save'" @click="() => save(record)"><a-icon type="check" /></a>
            <a-divider type="vertical"/>
            <a-popconfirm :title="$t('page_mdc_setting_close_edit')" @confirm="() => cancel(record)">
              <a v-acl="'page_mdc_setting_condition_cancel'" style="color: #ff0000"><a-icon type="close" /></a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a v-acl="'page_mdc_setting_condition_edit'" :disabled="editingKey !== '' || text == '0'" @click="() => edit(record.key)">{{$t('edit')}}</a>
            <a-divider type="vertical"/>
            <a-popconfirm :disabled="editingKey !== '' || text == '0'" :title="$t('page_mdc_setting_sure_delete')" @confirm="() => handleDelete(record)">
              <a v-acl="'page_mdc_setting_condition_delete'" :disabled="editingKey !== '' || text == '0'" :style="{color: (editingKey !== '' || text == '0') ? '#00000040' : '#ff0000'}">{{$t('delete')}}</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </ml-table>
    <a-button v-acl="'page_mdc_setting_condition_add'" :disabled="editingKey !== ''" type="primary" style="width: 100%;margin: 8px 0" @click="handleAdd()"><a-icon type="plus" />{{ $t('page_mdc_setting_add') }}</a-button>
  </div>
</template>
<script>
import { WorkStationWcsSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const wswssp = new WorkStationWcsSettingServiceProxy()
const data = [];
export default {
  data() {
    return {
      data: [],
      cacheData: [],
      columns:[
        {
          title: this.$t('page_mdc_setting_operation'),
          dataIndex: 'canEditor',
          width: 120,
          scopedSlots: { customRender: 'canEditor' },
        },
        {
          title: this.$t('page_mdc_setting_index'),
          dataIndex: 'code',
          width: '15%'
        },
        {
          title: this.$t('page_mdc_setting_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('page_mdc_setting_color'),
          dataIndex: 'color',
          width: '40%',
          scopedSlots: { customRender: 'color' },
        },
      ],
      editingKey: '',
      scrallHeight: 750,
      count: 0,
      loading: false
    };
  },
  created() {
    const scrall = document.querySelector('#app')
    this.scrallHeight = scrall.clientHeight - 215
    this.getList()
  },
  methods: {
    getList(){
      this.data = []
      this.loading = true
      wswssp.getWorkStationWcsSettingList().then(res =>{
        res.forEach(item =>{
          item.key = item.id
        })
        this.data = res
        this.count = (res.length + 1)
        this.loading = false
        this.cacheData = res.map(item => ({ ...item }));
      }).catch(() =>{
        this.loading = false
      })
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
        this.$emit('change', true)
      }
    },
    handleAdd() {
      const { count, data } = this;
      const newData = {
        key: count,
        editable: true,
        name: count,
        code: count,
        color: `#000000`,
      };
      this.editingKey = count
      this.data = [...data, newData];
      this.count = count + 1;
      this.$emit('change', true)
    },
    save(record) {
      const key = record.key
      if(record.id == undefined){
        const value = {
          "color": record.color,
          "wcsName": record.name,
          "wcsNum": record.code,
        }
        wswssp.insertWcsSetting(value).then(res =>{
          this.$message.success(this.$t('page_user_management_new_success'))
          this.getList()
        })
      } else {
        const value = {
          "code": record.code,
          "color": record.color,
          "id": record.id,
          "name": record.name
        }
        wswssp.updateWcsSetting(value).then(res =>{
          this.$message.success(this.$t('page_mdc_setting_edit_success'))
          this.getList()
        })
      }
      this.$emit('change', false)
      this.editingKey = '';
    },
    cancel(record) {
      const key = record.key
      if(record.id == undefined){
        const data = [...this.data];
        this.count -= 1
        this.data = data.filter(item => item.key !== key);
      } else {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.key)[0];
        if (target ) {
          Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
          delete target.editable;
          this.data = newData;
        }
      }
      this.$emit('change', false)
      this.editingKey = ''
    },
    handleDelete(record){
      if(record.id){
        wswssp.deleteWcsSetting(record.id).then(res => {
          this.$message.success(this.$t('page_mdc_setting_delete_success'))
          this.getList()
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.editable-row-operations a {
  margin-right: 8px;
}
 /deep/.box {
   position: fixed !important;
 }
</style>